import { DataType } from '@glueapp/graph-types';

// TODO replace this with an Open API based auto generated type from the slack api definition
export const SlackChannelType: DataType = {
    kind: 'object',
    properties: {
        id: { kind: 'string' },
        name: { kind: 'string' },
        is_channel: { kind: 'boolean' },
        is_group: { kind: 'boolean' },
        is_im: { kind: 'boolean' },
        created: { kind: 'number' },
        creator: { kind: 'string' },
        is_archived: { kind: 'boolean' },
        is_general: { kind: 'boolean' },
        unlinked: { kind: 'number' },
        name_normalized: { kind: 'string' },
        is_read_only: { kind: 'boolean' },
        is_shared: { kind: 'boolean' },
        is_ext_shared: { kind: 'boolean' },
        is_org_shared: { kind: 'boolean' },
        is_pending_ext_shared: { kind: 'boolean' },
        is_member: { kind: 'boolean' },
        is_private: { kind: 'boolean' },
        is_mpim: { kind: 'boolean' },
        last_read: { kind: 'string' },
        topic: {
            kind: 'object',
            properties: {
                value: { kind: 'string' },
                creator: { kind: 'string' },
                last_set: { kind: 'number' },
            },
            restriction: 'open',
        },
        purpose: {
            kind: 'object',
            properties: {
                value: { kind: 'string' },
                creator: { kind: 'string' },
                last_set: { kind: 'number' },
            },
            restriction: 'open',
        },
        previous_names: { kind: 'array', subType: { kind: 'string' } },
        num_members: { kind: 'number' },
        locale: { kind: 'string' },
    },
    restriction: 'open',
};

export interface Conversation {
    id: string;
    name: string;
    is_channel: boolean;
    is_group: boolean;
    is_im: boolean;
    created: number;
    creator: string;
    is_archived: boolean;
    is_general: boolean;
    unlinked: number;
    name_normalized: string;
    is_read_only: boolean;
    is_shared: boolean;
    is_ext_shared: boolean;
    is_org_shared: boolean;
    is_pending_ext_shared: boolean;
    is_member: boolean;
    is_private: boolean;
    is_mpim: boolean;
    last_read: string;
    topic: {
        value: string;
        creator: string;
        last_set: number;
    };
    purpose: {
        value: string;
        creator: string;
        last_set: number;
    };
    previous_names: string[];
    num_members: number;
    locale: string;
}
